import React from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";

import { DEFAULT_LICENSE_DAYS } from "../../constants/averageRates";
import PaywallView from "./PaywallView";
import RatesView from "./RatesView";

import "./AverageRates.scss";

const AverageRates = ({
  variant,
  averagePrice,
  minPrice,
  maxPrice,
  carType,
  carTypes,
  tonnageLabel,
  days,
  onCarTypeChange,
  onPayClick,
  analyticsHref,
  t,
  i18n,
}) => {
  if (variant === "paywall") {
    return (
      <PaywallView
        averagePrice={averagePrice}
        minPrice={minPrice}
        maxPrice={maxPrice}
        days={days}
        onPayClick={onPayClick}
        language={i18n.language}
        t={t}
      />
    );
  }

  return (
    <RatesView
      averagePrice={averagePrice}
      minPrice={minPrice}
      maxPrice={maxPrice}
      carType={carType}
      carTypes={carTypes}
      tonnageLabel={tonnageLabel}
      onCarTypeChange={onCarTypeChange}
      analyticsHref={analyticsHref}
      t={t}
    />
  );
};

AverageRates.propTypes = {
  variant: PropTypes.oneOf(["rates", "paywall"]).isRequired,
  averagePrice: PropTypes.number,
  minPrice: PropTypes.number,
  maxPrice: PropTypes.number,
  carType: PropTypes.string.isRequired,
  carTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      labelKey: PropTypes.string.isRequired,
      shortLabelKey: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  tonnageLabel: PropTypes.string.isRequired,
  days: PropTypes.number,
  onCarTypeChange: PropTypes.func,
  onPayClick: PropTypes.func,
  analyticsHref: PropTypes.string,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string,
  }).isRequired,
};

AverageRates.defaultProps = {
  averagePrice: null,
  minPrice: null,
  maxPrice: null,
  days: DEFAULT_LICENSE_DAYS,
  onCarTypeChange: () => {},
  onPayClick: () => {},
  analyticsHref: "#",
};

export default withNamespaces()(AverageRates);
